import { TooltipComponentOption } from 'echarts';

export const getChartTooltipPosition: TooltipComponentOption['position'] = (
  [mouseX, mouseY],
  _,
  dom,
  rect,
  { contentSize: [tooltipWidth, tooltipHeight] }
) => {
  if (mouseY < tooltipHeight) {
    return [mouseX - tooltipWidth / 2, mouseY + 25];
  }
  return [mouseX - tooltipWidth / 2, mouseY - tooltipHeight - 15];
};
